module.exports = __webpack_public_path__ + "img/v4.7ad31c48.png";